import { render, staticRenderFns } from "./PreRegistro.vue?vue&type=template&id=34ba8350&"
import script from "./PreRegistro.vue?vue&type=script&lang=js&"
export * from "./PreRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports